// extracted by mini-css-extract-plugin
module.exports = {"container":"gQ","image":"gR","title":"gS","desc":"gT"};